import moment from 'moment';
import 'moment/locale/es';
import { AxiosPrivado } from '../componentes/axios/Axios';
export const regexIdentidad = /^\d{13}$/;//validar identidad
export const regexRTN = /^\d{14}$/;//validar identidad
export const regexEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;//validar correo
export const regexContrasena = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_]).{6,15}$/;
export const regexNombre = /^[a-zA-Z0-9ñÑ\s]{3,50}$/;
export const regexNombreVacio = /^$|^[a-zA-Z0-9ñÑ\s]{3,50}$/;
export const regexDescripcion = /^$|^[a-zA-Z0-9ñÑ\s\S]{10,250}$/;
export const regexEntero = /^\d+$/;
export const regexDecimal = /^\d+(\.\d+)?$/;
export const regexEAN13 = /^\d{13}$/;
export const regexUPC = /^\d{4,15}$/;
export const regexCODE = /^[a-zA-Z0-9\s]{4,15}$/;
export const regexTelefono = /^\d{8,12}$/;
export const regexNombreValido = /^[a-zA-ZñÑáéíóúÁÉÍÓÚ\s]{3,}$/;
export const regexNombreOpcionalValido = /^[a-zA-ZñÑáéíóúÁÉÍÓÚ\s]+$/;

export const formatoMoneda = (valor) =>
    "L " +
    new Intl.NumberFormat("en-HN", { minimumFractionDigits: 2 }).format(
        parseFloat(valor || 0)
    );

export const formatoNumero = (valor) => String(valor || 0).padStart(8, "0");

export const formatoDecimal = (valor) => Math.round(valor * 100) / 100;

export const formatoFecha = (fecha) => {
    return moment(fecha).format('YYYY-MM-DD');
};

export const limpiarCamposVacios= (datos, camposOpcionales = [])=> {
  const resultado = {};

  for (const [clave, valor] of Object.entries(datos)) {
    const valorNormalizado = (valor ?? "").toString().trim();

    if (camposOpcionales.includes(clave)) {
      if (valorNormalizado !== "") {
        resultado[clave] = valor;
      }
    } else {
      resultado[clave] = valor;
    }
  }

  return resultado;
}

export const parseNum = (val) => parseFloat(val) || 0;